export default function CustomLegend({ payload, order }) {
  if (!payload) return null;

  const sorted = [...payload].sort((a, b) => {
    const indexA = order.indexOf(a.value);
    const indexB = order.indexOf(b.value);

    // Items not in order[] go to the end
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  });

  return (
    <ul style={{ display: "flex", listStyle: "none", padding: 0, margin: 0 }}>
      {sorted.map((entry, index) => (
        <li
          key={`item-${index}`}
          style={{ marginRight: 16, display: "flex", alignItems: "center" }}
        >
          <span
            style={{
              display: "inline-block",
              width: 12,
              height: 12,
              backgroundColor: entry.color,
              marginRight: 6,
            }}
          />
          {entry.value}
        </li>
      ))}
    </ul>
  );
}
